module.exports = __webpack_public_path__ + "img/AKA 1975.f34d6e66.png";